import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  padding: 2rem;

  background: #526571;
  border-right: 1px solid #a8b2b8;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  color: #fff;
  text-align: center;

  @media (min-width: 600px) {
    border-top-right-radius: 0;
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
`;

export const Title = styled.h2`
  font-size: 2rem;
  margin: 0;
  padding: 0;

  &::after {
    content: '';
    height: 3px;
    width: 40%;
    display: block;
    background: #f59947;
    margin: 1rem auto;
  }
`;

export const Description = styled.p`
  font-size: 1.2rem;
  strong {
    color: #f59947;
  }

  &::after {
    content: '';
    height: 3px;
    width: 40%;
    display: block;
    background: #f59947;
    margin: 1rem auto;
  }

  &:last-child::after {
    content: none;
  }
`;
